<template>
  <div class="Calculator">
    <div class="numericDisplay">
      <div class="container" v-bind:style="{ fontSize: fontSize + 'mm' }">
        {{ numericDisplayString }}
      </div>
    </div>

    <div class="keypad">
      <button @touchstart="touchStartHandler" @touchend="touchEndHandler" @click="clearButtonHandler" class="row1">{{ clearValue }}</button>
      <button @touchstart="touchStartHandler" @touchend="touchEndHandler" @click="flipSignHandler" class="row1">+/-</button>
      <button @touchstart="touchStartHandler" @touchend="touchEndHandler" @click="settingsTrigger" class="row1" >%</button>
      <button @touchstart="touchStartHandler" @touchend="touchEndHandler" @click="deleteHandler" class="row1">DEL</button>

      <button @touchstart="touchStartHandler" @touchend="touchEndHandler" @click="numericButtons">7</button>
      <button @touchstart="touchStartHandler" @touchend="touchEndHandler" @click="numericButtons">8</button>
      <button @touchstart="touchStartHandler" @touchend="touchEndHandler" @click="numericButtons">9</button>
      <button @touchstart="touchStartHandler" @touchend="touchEndHandler" @click="operatorHandler" class="last" v-bind:class="{ focus: (computationMode == 'divide' && showComputationMode) }" style="font-size: 20pt;">&divide;</button>

      <button @touchstart="touchStartHandler" @touchend="touchEndHandler" @click="numericButtons">4</button>
      <button @touchstart="touchStartHandler" @touchend="touchEndHandler" @click="numericButtons">5</button>
      <button @touchstart="touchStartHandler" @touchend="touchEndHandler" @click="numericButtons">6</button>
      <button @touchstart="touchStartHandler" @touchend="touchEndHandler" @click="operatorHandler" class="last" v-bind:class="{ focus: (computationMode == 'multiply' && showComputationMode) }">X</button>

      <button @touchstart="touchStartHandler" @touchend="touchEndHandler" @click="numericButtons">1</button>
      <button @touchstart="touchStartHandler" @touchend="touchEndHandler" @click="numericButtons">2</button>
      <button @touchstart="touchStartHandler" @touchend="touchEndHandler" @click="numericButtons">3</button>
      <button @touchstart="touchStartHandler" @touchend="touchEndHandler" @click="operatorHandler" class="last" v-bind:class="{ focus: (computationMode == 'subtract' && showComputationMode) }" style="font-size: 20pt;">-</button>

      <button @touchstart="touchStartHandler" @touchend="touchEndHandler" @click="numericButtons">0</button>
      <button @touchstart="touchStartHandler" @touchend="touchEndHandler" @click="decimalHandler">.</button>
      <button @touchstart="touchStartHandler" @touchend="touchEndHandler" @click="equalsHandler" class="equals">=</button>
      <button @touchstart="touchStartHandler" @touchend="touchEndHandler" @click="operatorHandler" class="last" v-bind:class="{ focus: (computationMode == 'addition' && showComputationMode) }" style="font-size: 20pt;">+</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Calculator',
  data() {
    return {
      computationMode: 'none',
      showComputationMode: true,
      inputNumber: true,

      isFloat: false,
      floatValueDivisor: 1,
      floatValue: 0,
      intValue: 0,
      numericDisplayString: '0',
      numericValue: 0,
      settingsButtonClicked: 0,
      previousNumber: 0,
      clearValue: 'AC',

      equalsTapped: 0,

      separatorOperator: 'multiply',
      forceNumberTap: 4,

      fontSize: 10.5833,
    };
  },
  methods: {
    touchStartHandler(e) {
      e.target.classList.add('active');
    },
    touchEndHandler(e) {
      e.target.classList.remove('active');
    },
    updateNumericValue() {
      this.numericValue = this.intValue + (this.floatValue / this.floatValueDivisor);
    },
    updateNumericDisplay() {
      this.numericDisplayString = Number(this.intValue).toLocaleString();

      if (this.isFloat) {
        this.numericDisplayString += '.'; // eslint-disable-line

        if (this.floatValue !== 0) {
          this.numericDisplayString += this.floatValue; // eslint-disable-line
        }
      }

      // this.numericDisplayString = this.numericDisplayString;

      // Update font size
      if (this.numericDisplayString.length > 11) {
        this.fontSize = 116.4163 / this.numericDisplayString.length;
      } else {
        this.fontSize = 10.5833;
      }
    },
    resetSettingsTrigger() {
      this.settingsButtonClicked = 0;
    },
    percentage() {
      this.intValue /= 100;
    },
    settingsTrigger() {
      const minimumSettingsTap = localStorage.getItem('minimumSettingsTap') || 4;
      this.settingsButtonClicked += 1;

      if (!localStorage.getItem('performPercentage')) {
        // this.percentage();
      }

      if (this.settingsButtonClicked >= minimumSettingsTap) {
        this.$router.push('Settings');
      }
    },
    equals() {
      let newValue = 0; // eslint-disable-line
      let multiplier = 1;
      let decimal = 0;
      let decimalLength = 0;

      switch (this.computationMode) {
        case 'addition':
          newValue = this.previousNumber + this.numericValue;
          break;
        case 'subtract':
          newValue = this.previousNumber - this.numericValue;
          break;
        case 'multiply':
          window.console.log(this.previousNumber * this.numericValue,
            this.previousNumber, this.numericValue);
          newValue = this.previousNumber * this.numericValue;
          break;
        case 'divide':
          newValue = this.previousNumber / this.numericValue;
          break;
        default:
          newValue = 0;
      }

      if (newValue < 0) {
        multiplier = -1;
      }

      this.clear();

      // Set the int value of the number system
      this.intValue = Math.floor(Math.abs(newValue));

      // Set the float value of the number system
      decimal = String(Math.abs(newValue) - this.intValue);
      decimal = decimal.split('.')[1];

      if (decimal) {
        this.isFloat = true;
        decimalLength = decimal.length;
        decimal = window.Number.parseInt(decimal);
      } else {
        decimal = 0;
        decimalLength = 1;
      }

      // Set float value divisor
      this.floatValue = decimal;
      this.floatValueDivisor = Math.pow(10, decimalLength); // eslint-disable-line
      this.intValue *= multiplier;

      if (this.equalsTapped >= this.forceNumberTap) {
        this.isFloat = false;
        this.intValue = localStorage.getItem('forceNumber');
      }

      this.updateValues();
    },
    clear() {
      this.computationMode = 'none';
      this.showComputationMode = true;
      this.floatValueDivisor = 1;
      this.numericDisplayString = '0';
      this.numericValue = 0;
      this.settingsButtonClicked = 0;
      this.previousNumber = 0;

      this.clearNumberSystem();
    },
    pushNumericDisplay(num) {
      if (!this.isFloat) {
        let newNum = this.intValue;

        newNum *= 10;
        newNum += num;

        this.intValue = newNum;
      } else {
        let newNum = this.floatValue;

        newNum *= 10;
        newNum += num;

        this.floatValue = newNum;
        this.floatValueDivisor *= 10;
      }
    },
    clearNumberSystem() {
      this.floatValue = 0;
      this.intValue = 0;
      this.isFloat = false;
      this.floatValueDivisor = 1;
    },
    clearButtonHandler() {
      this.resetSettingsTrigger();
      if (this.floatValue !== 0 || this.intValue !== 0) { // C
        this.clearNumberSystem();
        this.floatValueDivisor = 1;
      } else { // AC
        this.clear();
        this.equalsTapped = 0;
        this.$root.$data.values = [];
      }
    },
    numericButtons(e) {
      if (this.numericDisplayString.length >= 11 && this.computationMode === 'none') {
        return;
      }

      if (this.computationMode !== 'none' && !this.inputNumber) {
        this.previousNumber = this.numericValue;
        this.showComputationMode = false;

        this.clearNumberSystem();

        this.inputNumber = true;
      }

      const num = window.Number.parseInt(e.toElement.innerText);
      this.pushNumericDisplay(num);
      this.resetSettingsTrigger();
    },
    decimalHandler() {
      let newNum = this.intValue;
      newNum *= 1.0;

      this.isFloat = true;
      this.updateNumericDisplay(newNum);
    },
    storeValue() {
      this.$root.$data.values.push(this.intValue);
      this.equalsTapped += 1;
    },
    operatorHandler(e) {
      let computationMode = 'none';

      switch (e.toElement.innerText) {
        case '+':
          computationMode = 'addition';
          break;
        case '-':
          computationMode = 'subtract';
          break;
        case 'X':
          computationMode = 'multiply';
          break;
        default:
          computationMode = 'divide';
          break;
      }

      if (this.separatorOperator === computationMode) {
        this.storeValue();
      }

      if (this.computationMode !== 'none') {
        this.equals();
        this.previousNumber = this.numericValue;
        this.showComputationMode = true;
      }

      this.computationMode = computationMode;

      this.inputNumber = false;
    },
    equalsHandler() {
      if (this.computationMode !== 'none') {
        this.storeValue();
        this.equals();
        this.computationMode = 'none';
      }
    },
    flipSignHandler() {
      this.intValue *= -1;
    },
    updateClearValue() {
      if (this.floatValue !== 0 || this.intValue !== 0) { // C
        this.clearValue = 'C';
      } else { // CA
        this.clearValue = 'AC';
      }
    },
    deleteHandler() {
      if (this.isFloat) {
        this.floatValue = Math.floor(this.floatValue / 10);
        this.floatValueDivisor /= 10;
      } else {
        this.intValue = Math.floor(this.intValue / 10);
      }

      if (this.floatValue === 0) {
        this.isFloat = false;
        this.floatValue = 0;
      }
    },
    updateValues() {
      this.updateNumericValue();
      this.updateNumericDisplay();
      this.updateClearValue();
    },
  },
  watch: {
    floatValue() {
      this.updateValues();
    },
    intValue() {
      this.updateValues();
    },
  },
  mounted() {
    // Initial setup
    if (!localStorage.getItem('minimumSettingsTap')) {
      localStorage.setItem('forceNumber', String((new Date()).getTime()));
      localStorage.setItem('minimumSettingsTap', String(4));
      localStorage.setItem('separatorOperator', 'multiply');
      localStorage.setItem('forceNumberTap', String(4));
    }

    // Reload data from previous session
    this.computationMode = localStorage.getItem('computationMode') || 'none';
    this.floatValueDivisor = window.Number.parseInt(localStorage.getItem('floatValueDivisor')) || 10;
    this.floatValue = window.Number.parseInt(localStorage.getItem('floatValue')) || 0;
    this.intValue = window.Number.parseInt(localStorage.getItem('intValue')) || 0;
    this.numericDisplayString = localStorage.getItem('numericDisplayString') || '0';
    this.previousNumber = window.Number.parseFloat(localStorage.getItem('previousNumber')) || 0;
    this.equalsTapped = window.Number.parseFloat(localStorage.getItem('equalsTapped')) || 0;

    this.showComputationMode = localStorage.getItem('showComputationMode') || true;
    this.inputNumber = localStorage.getItem('inputNumber') || true;
    this.isFloat = localStorage.getItem('isFloat') || false;

    if (typeof this.showComputationMode === 'string') {
      this.showComputationMode = this.showComputationMode === 'true';
    }
    if (typeof this.inputNumber === 'string') {
      this.inputNumber = this.inputNumber === 'true';
    }
    if (typeof this.isFloat === 'string') {
      this.isFloat = this.isFloat === 'true';
    }

    this.separatorOperator = localStorage.getItem('separatorOperator');
    this.forceNumberTap = window.Number.parseInt(localStorage.getItem('forceNumberTap'));

    this.updateNumericValue();
    this.updateNumericDisplay();
  },
  beforeRouteLeave(to, from, next) {
    localStorage.setItem('computationMode', this.computationMode);
    localStorage.setItem('inputNumber', this.inputNumber);
    localStorage.setItem('showComputationMode', this.showComputationMode);
    localStorage.setItem('isFloat', this.isFloat);
    localStorage.setItem('floatValueDivisor', this.floatValueDivisor);
    localStorage.setItem('floatValue', this.floatValue);
    localStorage.setItem('intValue', this.intValue);
    localStorage.setItem('numericDisplayString', this.numericDisplayString);
    localStorage.setItem('numericValue', this.numericValue);
    localStorage.setItem('settingsButtonClicked', this.settingsButtonClicked);
    localStorage.setItem('previousNumber', this.previousNumber);
    localStorage.setItem('equalsTapped', this.equalsTapped);
    next();
  },
};
</script>

<style>
/* Character width is roughly 5.41 units at 1pt */
/* 30pt = width of 23.98 units */
.Calculator {
  font-family: 'courier-prime-sans'
}

.numericDisplay {
  width: 100%;
  text-align: right;
  height: 110px;
  vertical-align: middle;
  line-height: 80px;
}

.numericDisplay .container {
  padding: 15px 10px;
  font-size: 10.5833mm;
}

.keypad {
  width: 100%;
  height: calc(100vh - 110px);
  text-align: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.keypad button {
  text-align: center;
  width: 25vw;
  height: 20%;
  padding: 0;
  margin: 0;
  display: inline-block;
  background: #ffffff;
  border: none;
  color: #D9853F;
  font-size: 15pt;
  font-weight: 600;
  outline: none;
  transition: filter 0.08s ease-in-out, box-shadow 0.1s ease-in-out;
}

.keypad button.focus {
  filter: brightness(1.5);
  box-shadow: 0 0 6px 0px rgba(0, 0, 0, 0.8);
}

.keypad button.active,
.keypad button:active {
  filter: brightness(0.9);
  box-shadow: inset 0 0 3px 0px rgba(0, 0, 0, 0.8);
}

.keypad button.row1 {
  background: #E5E5E5;
  color: #666666;
}

.keypad button.last {
  background: #C9C9C9;
  color: #666666;
}

.keypad button.equals {
  /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#d9853f+0,e4ab77+100 */
  background: #D9853F; /* Old browsers */
  background: -moz-linear-gradient(45deg,  #d9853f 0%, #e4ab77 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(45deg,  #d9853f 0%,#e4ab77 100%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(45deg,  #d9853f 0%,#e4ab77 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#d9853f', endColorstr='#e4ab77',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */

  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/Calculator.vue